// List of country codes that fallback to romanized versions of month names in Safari (iOS/MacOs)

export const countriesWithWrongMonthName = ["SA"];
